import React, { FC } from 'react'
import { sanitize } from 'dompurify'

interface IToolLearnMoreProps {
  longDescription?: string
}
const ToolLearnMore: FC<IToolLearnMoreProps> = ({ longDescription }) => {
  return <div dangerouslySetInnerHTML={{ __html: sanitize(longDescription || '') }} />
}

export default ToolLearnMore
